import eventQueue from '../queue';
import { EventAction, EventSurface } from '../../types/events';
function attachEventListeners() {
    eventQueue.on('ui', function (_a) {
        var data = _a.data, state = _a.state, fireAnalyticsEvent = _a.fireAnalyticsEvent;
        if (data.element === 'Hint' &&
            data.open &&
            state.segment.currentSource === EventSurface.LOGIN) {
            fireAnalyticsEvent(EventAction.HINT_EXPANDED, {
                // Allows us to differentiate between multiple <Hint> components on a
                // surface (e.g. whether the hint was for the username or password).
                eventId: data.eventId,
            });
        }
    });
}
attachEventListeners();
